import { isoZ, z } from 'my-zod'

export const departmentProgramType = z
  .enum([
    'Marketing',
    'Engineering',
    'SalesDemo',
    'CorporateUnknown',
    'EmployeePolarisOwnedUnits',
    'FleetSaleOnly',
    'IndianMotorcycleRentals',
    'Marine'
  ])
  .setEnumLabels({
    EmployeePolarisOwnedUnits: 'Employee Polaris Owned Units',
    Marketing: 'Marketing',
    Engineering: 'Engineering',
    SalesDemo: 'Sales Demo',
    CorporateUnknown: 'Corporate (Unknown)', //this is only used when we try to automatically create a corp fleet vehicle but don't have the existing department in our system...should be very rare
    FleetSaleOnly: 'Fleet Sale Only',
    IndianMotorcycleRentals: 'Indian Motorcycle Rentals',
    Marine: 'Marine'
  })

export const departmentsModel = z.object({
  id: z.number(),
  programType: departmentProgramType,
  ibmiDepartmentNumber: z.string(),
  ibmiDepartmentOwner: z.string().nullable(),
  ibmiCustomerNumber: z.string(),
  ibmiCustomerName: z.string().nullable(),
  ibmiDepartmentGroup: z.string().nullable(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant()
})

export type departmentsModel = z.infer<typeof departmentsModel>
